import { render, staticRenderFns } from "./settings-organization-general.vue?vue&type=template&id=7857de8b&scoped=true&"
import script from "./settings-organization-general.vue?vue&type=script&lang=js&"
export * from "./settings-organization-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7857de8b",
  null
  
)

export default component.exports